import { RealtimeModes as modes } from "mobility-toolbox-js/ol";
import { memo, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setBackgroundLayer } from "../model/actions";

function BackgroundLayer() {
  const map = useSelector((state) => state.map);
  const mode = useSelector((state) => state.mode);
  const topographicBgLayer = useSelector((state) => state.topographicBgLayer);
  const schematicBgLayer = useSelector((state) => state.schematicBgLayer);
  const dispatch = useDispatch();

  const layer = useMemo(() => {
    schematicBgLayer?.setZIndex(-1);
    topographicBgLayer?.setZIndex(-1);
    schematicBgLayer?.setVisible(true);
    topographicBgLayer?.setVisible(true);
    return mode === modes.SCHEMATIC ? schematicBgLayer : topographicBgLayer;
  }, [mode, schematicBgLayer, topographicBgLayer]);

  useEffect(() => {
    dispatch(setBackgroundLayer(layer));
  }, [dispatch, layer]);

  useEffect(() => {
    if (layer) {
      map?.addLayer(layer);
    }
    return () => {
      map?.removeLayer(layer);
    };
  }, [layer, map]);

  return null;
}

export default memo(BackgroundLayer);
